import React from "react";

import { DeviceStatus, MdmDeviceDto, useGetAllDevicesByProjectQuery } from "gql/generated/types";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Link } from "react-router-dom";
import { TableColumn } from "utils/types";
import DeviceStatusTag from "../components/DeviceStatus";
import MainTable from "../components/MainTable";
import useProjectContext from "../hooks/useProjectContext";

const Devices = () => {
  const {projectId, project} = useProjectContext();

  const { data: deviceData, loading } = useGetAllDevicesByProjectQuery({
    variables: { id: projectId! },
    skip: !projectId,
  });

  const edit = (rowData: MdmDeviceDto) => (
    <Link to={`${rowData.id}`} title="Device Info">
      {rowData.identifier}
    </Link>
  );

  const handleStatus = (rowData: MdmDeviceDto) => (
    <DeviceStatusTag
      status={rowData.status.status}
      lastMeasurementDate={rowData.status.lastMeasurementDate}
    />
  );
  
  const statusRowFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
    const statusOptionTemplate = (option: DeviceStatus) => <DeviceStatusTag status={option} />
    return (
      <Dropdown
        value={options.value}
        options={Object.values(DeviceStatus)}
        onChange={e => options.filterApplyCallback(e.value)}
        valueTemplate={options.value && <DeviceStatusTag status={options.value} />}
        itemTemplate={statusOptionTemplate}
        placeholder="Select One"
        showClear
      />
    );
  }

  const columns: TableColumn<MdmDeviceDto>[] = [
    { field: "identifier", header: "Identifier",body: edit, sortable: true, filter: true },
    {
      field: "objectRelation.mdmObject.identifier",
      header: "Object Code",
      sortable: true,
      filter: true,
    },
    {
      field: "objectRelation.roleInObject",
      header: "Type",
      body: rowData =>
        project?.mdmProjectById.configuration?.deviceConfiguration.measurementTypes?.find(
          type => type?.id === rowData.objectRelation?.roleInObject
        )?.title ?? "",
      sortable: true,
    },
    { field: "config.title", header: "Config", sortable: true },
    {
      field: "status.status",
      header: "Status",
      body: handleStatus,
      filter: true,
      filterElement: statusRowFilterTemplate,
      showFilterMenuOptions: false,
      showApplyButton: false,
      showClearButton: false,
      sortable: true,
      hideInFile: true,
    },
  ];

  return (
    <MainTable
      columns={columns}
      data={(deviceData?.mdmDevicesByProjectId ?? []) as MdmDeviceDto[]}
      tableType="device"
      searchFields={["identifier", "tags"]}
      loading={loading}
    />
  );
};

export default Devices;